var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box } from '@mui/material';
import React from 'react';
import { themeColors, themeMode } from '../JuvareTheme';
export const StandardCard = (_a) => {
    var { sx, children } = _a, props = __rest(_a, ["sx", "children"]);
    return (React.createElement(Box, { sx: [
            {
                position: 'relative',
                backgroundColor: 'background.paper',
                border: '1px solid ' + themeColors.border.main,
                borderRadius: 1,
                outline: themeMode === 'light' ? 'none' : '1px solid transparent',
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ], "data-test": props['data-test'] }, children));
};
